type Props = {
  className?: string;
};

export const DonationVerifiedByDonioIcon = ({ className }: Props) => {
  return (
    <svg
      width="24"
      height="25"
      className={className}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19923_211967)">
        <mask id="mask0_19923_211967" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
          <rect y="0.76416" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_19923_211967)">
          <path
            d="M11.9996 21.7363L8.62461 22.8613C8.50794 22.8947 8.39961 22.9197 8.29961 22.9363C8.19961 22.953 8.09961 22.9613 7.99961 22.9613C7.46628 22.9613 6.99961 22.7738 6.59961 22.3988C6.19961 22.0238 5.99961 21.5447 5.99961 20.9613V15.5113L3.39961 11.2863C3.29961 11.1197 3.22461 10.9488 3.17461 10.7738C3.12461 10.5988 3.09961 10.4197 3.09961 10.2363C3.09961 10.053 3.12461 9.87383 3.17461 9.69883C3.22461 9.52383 3.29961 9.35299 3.39961 9.18633L6.79961 3.68633C6.98294 3.38633 7.22461 3.15299 7.52461 2.98633C7.82461 2.81966 8.14961 2.73633 8.49961 2.73633H15.4996C15.8496 2.73633 16.1746 2.81966 16.4746 2.98633C16.7746 3.15299 17.0163 3.38633 17.1996 3.68633L20.5996 9.18633C20.6996 9.35299 20.7746 9.52383 20.8246 9.69883C20.8746 9.87383 20.8996 10.053 20.8996 10.2363C20.8996 10.4197 20.8746 10.5988 20.8246 10.7738C20.7746 10.9488 20.6996 11.1197 20.5996 11.2863L17.9996 15.5113V20.9613C17.9996 21.5447 17.7996 22.0238 17.3996 22.3988C16.9996 22.7738 16.5329 22.9613 15.9996 22.9613C15.8996 22.9613 15.7996 22.953 15.6996 22.9363C15.5996 22.9197 15.4913 22.8947 15.3746 22.8613L11.9996 21.7363ZM11.9996 19.6363L15.9996 20.9613V17.7363H7.99961V20.9613L11.9996 19.6363ZM8.49961 15.7363H15.4996L18.8996 10.2363L15.4996 4.73633H8.49961L5.09961 10.2363L8.49961 15.7363ZM10.9496 11.4863L14.4746 7.93633C14.6579 7.73633 14.8871 7.64049 15.1621 7.64883C15.4371 7.65716 15.6746 7.753 15.8746 7.93633C16.0746 8.13633 16.1788 8.37383 16.1871 8.64883C16.1954 8.92383 16.0996 9.16133 15.8996 9.36133L11.6496 13.6113C11.4496 13.8113 11.2163 13.9113 10.9496 13.9113C10.6829 13.9113 10.4496 13.8113 10.2496 13.6113L8.12461 11.4863C7.92461 11.2863 7.82461 11.0488 7.82461 10.7738C7.82461 10.4988 7.92461 10.2613 8.12461 10.0613C8.32461 9.86133 8.56211 9.76133 8.83711 9.76133C9.11211 9.76133 9.34961 9.86133 9.54961 10.0613L10.9496 11.4863Z"
            fill="#299B29"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_19923_211967">
          <rect width="24" height="24" fill="white" transform="translate(0 0.76416)" />
        </clipPath>
      </defs>
    </svg>
  );
};
